// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-container {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  align-items: center;
  justify-content: center;
  padding: 8rem 3rem 7rem 3rem;
}

.detail-container h1 {
  font-weight: 500;
  font-size: 2.5rem;
  text-align: center;
  color: var(--variant-2);
}

.detail-container h1 span {
  color: var(--txt);
}

.details {
  padding-top: 0.5rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
  width: 100%;
  padding-bottom: 4rem;
}

.details img {
  width: 100%;
  max-width: 780px;
}

.restaurant {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

#name {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

#name svg {
  fill: var(--variant-2);
}

#loc {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  color: #80807e;
}

#loc svg {
  fill: #80807e;
}

#desc {
  text-align: left;
}

#categ strong {
  color: #000;
}

#categ {
  color: #80807e;
}

#foodMenu {
  text-align: justify;
}

#drinkMenu {
  text-align: justify;
}

/* reviews */
#reviews-container {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  padding-bottom: 7rem;
  gap: 4rem;
  flex-wrap: wrap;
  padding-top: 1rem;
}

#rev {
  font-size: 2.5rem;
  font-weight: 500;
  padding-top: 7rem;
  text-align: center;
}

.review {
  width: 100%;
  max-width: 550px;
  padding: 2rem 2rem 2rem 2rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

#rev-date {
  color: #80807e;
  font-size: 0.8rem;
  text-align: end;
}

#rev-txt {
  text-align: left;
  font-size: 1rem;
}

#rev-name {
  text-align: left;
  font-size: 0.9rem;
  font-weight: 400;
  color: #80807e;
}

/*
  Like
*/
.like {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--variant-2);
  position: fixed;
  bottom: 80px;
  right: 16px;
  border-radius: 50%;
  border: 0;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}

.like:hover{
  transform: scale(1.1);
  transition: 0.3s;
}
`, "",{"version":3,"sources":["webpack://./src/styles/detail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".detail-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  align-items: center;\n  justify-content: center;\n  padding: 8rem 3rem 7rem 3rem;\n}\n\n.detail-container h1 {\n  font-weight: 500;\n  font-size: 2.5rem;\n  text-align: center;\n  color: var(--variant-2);\n}\n\n.detail-container h1 span {\n  color: var(--txt);\n}\n\n.details {\n  padding-top: 0.5rem;\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  width: 100%;\n  padding-bottom: 4rem;\n}\n\n.details img {\n  width: 100%;\n  max-width: 780px;\n}\n\n.restaurant {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n#name {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n}\n\n#name svg {\n  fill: var(--variant-2);\n}\n\n#loc {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.9rem;\n  color: #80807e;\n}\n\n#loc svg {\n  fill: #80807e;\n}\n\n#desc {\n  text-align: left;\n}\n\n#categ strong {\n  color: #000;\n}\n\n#categ {\n  color: #80807e;\n}\n\n#foodMenu {\n  text-align: justify;\n}\n\n#drinkMenu {\n  text-align: justify;\n}\n\n/* reviews */\n#reviews-container {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: row;\n  padding-bottom: 7rem;\n  gap: 4rem;\n  flex-wrap: wrap;\n  padding-top: 1rem;\n}\n\n#rev {\n  font-size: 2.5rem;\n  font-weight: 500;\n  padding-top: 7rem;\n  text-align: center;\n}\n\n.review {\n  width: 100%;\n  max-width: 550px;\n  padding: 2rem 2rem 2rem 2rem;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n}\n\n#rev-date {\n  color: #80807e;\n  font-size: 0.8rem;\n  text-align: end;\n}\n\n#rev-txt {\n  text-align: left;\n  font-size: 1rem;\n}\n\n#rev-name {\n  text-align: left;\n  font-size: 0.9rem;\n  font-weight: 400;\n  color: #80807e;\n}\n\n/*\n  Like\n*/\n.like {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--variant-2);\n  position: fixed;\n  bottom: 80px;\n  right: 16px;\n  border-radius: 50%;\n  border: 0;\n  font-size: 18px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.like:hover{\n  transform: scale(1.1);\n  transition: 0.3s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
